"use strict";
/**
 * @license
 * Copyright 2022 SOUTHWORKS UK LTD All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/southworks/codeverter/blob/main/LICENSE
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguageGenerator = void 0;
const csharp_generator_1 = require("./templating/csharp/csharp-generator");
const go_generator_1 = require("./templating/go/go-generator");
const custom_generator_1 = require("./templating/custom/custom-generator");
const vb_generator_1 = require("./templating/vb/vb-generator");
function getLanguageGenerator(lang, ...params) {
    switch (lang) {
        case "go": return new go_generator_1.GoGenerator();
        case "csharp": return new csharp_generator_1.CSharpGenerator();
        case "custom": return new custom_generator_1.CustomGenerator(params[0]);
        case "vb": return new vb_generator_1.VBGenerator();
    }
}
exports.getLanguageGenerator = getLanguageGenerator;
